import { ShieldCheck, MessageCircle, Star } from 'lucide-react';
import { COMPANY } from '../../data/legalContent';
import { MANIFESTO, waReviewLink } from './reviewUtils';

const ICONS = [ShieldCheck];

export const Manifesto = ({ compact = false }) => (
  <div className={compact ? 'flex flex-wrap gap-2' : 'border-y border-[#111214]/15'} data-testid="reviews-manifesto">
    {MANIFESTO.map((m, i) => {
      const Icon = ICONS[i];
      if (compact) {
        return (
          <span key={m.n} className="inline-flex items-center gap-1.5 text-xs text-[#52525B] bg-white border border-[#E4E4E7] rounded-full px-3 py-1.5" title={m.text} data-testid={`reviews-manifesto-chip-${i}`}>
            <Icon className="w-3.5 h-3.5 text-[#E02128]" /> {m.title}
          </span>
        );
      }
      return (
        <div key={m.n} className="py-6 sm:py-7 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-8" data-testid={`reviews-manifesto-item-${i}`}>
          <div className="flex items-center gap-3 shrink-0">
            <span className="font-mono text-[11px] tracking-[0.2em] text-[#E02128]">{m.n}</span>
            <Icon className="w-5 h-5 text-[#111214]" aria-hidden="true" />
            <h3 className="font-heading font-bold text-[#111214] text-lg sm:text-xl leading-tight">{m.title}</h3>
          </div>
          <p className="text-sm sm:text-base text-[#52525B] leading-relaxed sm:border-l sm:border-[#111214]/15 sm:pl-8">{m.text}</p>
        </div>
      );
    })}
  </div>
);

export const Marquee = ({ reviews }) => {
  const quotes = reviews.filter((r) => (r.body || '').trim().length > 12 && r.rating >= 4).slice(0, 8);
  if (quotes.length < 2) return null;
  const items = [...quotes, ...quotes];
  return (
    <div className="relative overflow-hidden bg-[#090A0C] text-white py-5 select-none" aria-hidden="true" data-testid="reviews-marquee">
      <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-[#090A0C] to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-[#090A0C] to-transparent z-10" />
      <div className="dy-marquee flex w-max gap-10 hover:[animation-play-state:paused]">
        {items.map((r, i) => (
          <span key={i} className="inline-flex items-center gap-4 whitespace-nowrap">
            <span className="inline-flex gap-0.5">{Array.from({ length: r.rating }).map((_, k) => <Star key={k} className="w-3.5 h-3.5 text-[#E02128] fill-[#E02128]" />)}</span>
            <span className="font-heading text-base sm:text-lg text-zinc-100">“{r.body.trim().replace(/\s+/g, ' ').slice(0, 110)}{r.body.trim().length > 110 ? '…' : ''}”</span>
            <span className="font-mono text-[11px] tracking-wider uppercase text-zinc-500">{r.name}{r.city ? ` · ${r.city}` : ''}</span>
            <span className="w-1.5 h-1.5 rounded-full bg-[#E02128]" />
          </span>
        ))}
      </div>
    </div>
  );
};

export const ReviewCta = ({ product, dark = false }) => (
  <div className={`flex flex-col sm:flex-row sm:items-center gap-4 rounded-2xl p-5 sm:p-6 border ${dark ? 'bg-[#121418] border-white/10' : 'bg-[#111214] border-[#111214]'}`} data-testid="reviews-cta">
    <div className="flex-1">
      <p className="font-mono text-[11px] tracking-[0.2em] uppercase text-zinc-400">Bought a DYSSC paddle?</p>
      <h3 className="font-heading font-bold text-white text-lg sm:text-xl mt-1">Send your honest review on WhatsApp.</h3>
      <p className="text-zinc-400 text-sm mt-1">It goes up under your first name after a quick check — matched to your order.</p>
    </div>
    <a href={waReviewLink(COMPANY.whatsapp, product)} target="_blank" rel="noopener noreferrer"
      className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-[#25D366] hover:bg-[#1fb857] text-[#062b16] font-semibold text-sm transition-colors shrink-0"
      data-testid="reviews-whatsapp-cta">
      <MessageCircle className="w-4 h-4" /> Write a review on WhatsApp
    </a>
  </div>
);
